import { createSlice } from "@reduxjs/toolkit";

export interface PanoState {
    panoCoordinate: [number, number];
    panoGotoCoordinate: [number, number];
    viewAngle: number;
    viewFov: number;
}

const initialState: PanoState = {
    panoCoordinate: [32.55952766405587,39.97679792936009],
    panoGotoCoordinate: [32.55952766405587,39.97679792936009],
    viewAngle: 0,
    viewFov: 0.8333333333333334
};

export const panoSlice = createSlice({
    name: 'panoState',
    initialState,
    reducers: {
        setPanoCoordinate: (state: PanoState, action) => {
            state.panoCoordinate = action.payload;
        },
        setPanoGotoCoordinate: (state: PanoState, action) => { 
            state.panoGotoCoordinate = action.payload;
        },
        setViewAngle: (state: PanoState, action) => {
            state.viewAngle = action.payload;
        },
        setViewFov: (state: PanoState, action) => {
            state.viewFov = action.payload;
        },
    }
})

export const { setPanoCoordinate, setPanoGotoCoordinate, setViewAngle, setViewFov } = panoSlice.actions;
export default panoSlice.reducer;